import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'worldnet',
  name: 'WorldNet Global',
  isSystemTenant: false,
  domains: [
    'worldnet.localhost',
    'worldnet.demo.pelicargo.dev',
    'worldnet.tenant.pelicargo.dev',
    'worldnetus.com',
    /worldnet\.staging-\d+\.pelicargo\.dev/,
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#FEF6E8',
        '100': '#FBEBCE',
        '200': '#F4D7A2',
        '300': '#E8B83A',
        '400': '#D3A23B',
        '500': '#C9961E',
        '600': '#AC7E05',
        '700': '#8B6605',
        '800': '#6C4E01',
        '900': '#513900',
      },
      secondary: {
        '50': '#F3F7FC',
        '100': '#E6EEF7',
        '200': '#CFDCEC',
        '300': '#A8BCD2',
        '400': '#7A90AB',
        '500': '#596E87',
        '600': '#3C4F66',
        '700': '#2A3B57',
        '800': '#1E2D47',
        '900': '#0B1221',
      },
    },
    logoDims: {
      height: 16,
      width: undefined,
    },
    fullLogoDims: {
      height: '80px',
      width: '320px',
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#C9961E',
  },
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/worldnet/logo.png',
    'logo-dark':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/worldnet/worldnet_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/worldnet/worldnet_dark.svg',
    'logo-light':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/worldnet/worldnet_light.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/worldnet/worldnet_light.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://to-be-determined/',
    siteUrl: 'https://worldnetus.com',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      'ai-inbox': false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  customer: {
    requestFormDefaults: {
      freight_service: 'EXW',
      is_consolidated: true,
      extra_freight_services: [],
    },
    freightServices: {
      UNCERTIFIED: ['EXW', 'FCA'],
      default: ['EXW', 'FCA'],
    },
  },
  termsOfService: tos,
  helpUrl: 'https://docs.google.com/document/d/1CPAqKNH8qkimkl9ONXIB-8Lh-n9VbJTe9diBDWWqsW4/edit?usp=drive_link',
} as const satisfies TenantInfo<'worldnet'>;
